import React, { createContext, useContext, useState, useCallback } from "react";
import {
    Box, Button, TextField, Typography, Grid, FormControl, Checkbox,
    FormControlLabel,
    Switch, Snackbar,
    Alert,
    AlertProps
} from "@mui/material";
import { SnackBarContextType } from "../Types/CommonTypes";


const SnackbarContext = createContext<SnackBarContextType>({
    showSnackbar: () => { },
});

export const useSnackbar = () => useContext(SnackbarContext);


export const SnackbarProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [snackbar, setSnackbar] = useState<Pick<AlertProps, "children" | "severity"> | null>(null);
    const [open, setOpen] = useState(false);

    const showSnackbar = useCallback((message: string, severity: AlertProps["severity"] = "info") => {
        setOpen(false); 

        setTimeout(() => {
            setSnackbar({ children: message, severity });
            setOpen(true);
        }, 100); 
    }, []);
    const handleCloseSnackbar = () => {
        setSnackbar(null);
        setOpen(false);
    };

    return (
        <SnackbarContext.Provider value={{ showSnackbar }}>
            {children}
            {!!snackbar && (
                <Snackbar
                    open={open}
                    anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
                    onClose={handleCloseSnackbar}
                    autoHideDuration={6000}
                >
                    <Alert {...snackbar} onClose={handleCloseSnackbar} />
                </Snackbar>
            )}
        </SnackbarContext.Provider>
    );
};